/**
 * @generated SignedSource<<5e462c1fdeed4f0cc6d5b056118e5052>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateWebFormAnswerInput = {
  answer: WebFormAnswerInput;
  contentUsageId?: string | null;
  isCompleting?: boolean | null;
  webFormQuestionId: string;
};
export type WebFormAnswerInput = {
  body?: string | null;
  isSkipped?: boolean | null;
  selectedOptions?: ReadonlyArray<string> | null;
  webFormQuestionId: string;
};
export type QuizSubmissionEditorFormMutation$variables = {
  input: CreateWebFormAnswerInput;
};
export type QuizSubmissionEditorFormMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly answers: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly body: string | null;
            readonly id: string;
            readonly isCorrect: boolean | null;
            readonly isSkipped: boolean;
            readonly result: {
              readonly correctIds: ReadonlyArray<string>;
              readonly incorrectSelections: ReadonlyArray<string>;
            } | null;
            readonly selectedOptions: ReadonlyArray<string> | null;
            readonly webFormQuestionId: string;
          };
        }>;
      };
      readonly completedAt: string | null;
      readonly contentUsage: {
        readonly " $fragmentSpreads": FragmentRefs<"ContentUsageUtils_ContentCompletionFragment">;
      } | null;
      readonly durationSeconds: number | null;
      readonly hasAnswerKey: boolean;
      readonly hasPassed: boolean | null;
      readonly id: string;
      readonly result: {
        readonly correctAnswers: ReadonlyArray<{
          readonly id: string;
        }>;
        readonly incorrectAnswers: ReadonlyArray<{
          readonly id: string;
        }>;
        readonly percentage: number;
        readonly score: number;
        readonly total: number;
      } | null;
      readonly webFormId: string;
      readonly webFormRevisionId: string;
    } | null;
  };
};
export type QuizSubmissionEditorFormMutation = {
  response: QuizSubmissionEditorFormMutation$data;
  variables: QuizSubmissionEditorFormMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webFormId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "webFormRevisionId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "completedAt",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "durationSeconds",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasAnswerKey",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPassed",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "WebFormAnswerNodeConnection",
  "kind": "LinkedField",
  "name": "answers",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "WebFormAnswerNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "WebFormAnswer",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "body",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "selectedOptions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "webFormQuestionId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isSkipped",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isCorrect",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "WebFormAnswerResult",
              "kind": "LinkedField",
              "name": "result",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "correctIds",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "incorrectSelections",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v10 = [
  (v2/*: any*/)
],
v11 = {
  "alias": null,
  "args": null,
  "concreteType": "WebFormSubmissionResult",
  "kind": "LinkedField",
  "name": "result",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "score",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "total",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "percentage",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WebFormAnswer",
      "kind": "LinkedField",
      "name": "correctAnswers",
      "plural": true,
      "selections": (v10/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "WebFormAnswer",
      "kind": "LinkedField",
      "name": "incorrectAnswers",
      "plural": true,
      "selections": (v10/*: any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerHasCompleted",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLocked",
  "storageKey": null
},
v15 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ContentUsageNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ContentUsage",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v17 = [
  (v16/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "QuizSubmissionEditorFormMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "CreateWebFormAnswerResponse",
        "kind": "LinkedField",
        "name": "createWebFormAnswer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WebFormSubmission",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentUsage",
                "kind": "LinkedField",
                "name": "contentUsage",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ContentUsageUtils_ContentCompletionFragment"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "QuizSubmissionEditorFormMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v1/*: any*/),
        "concreteType": "CreateWebFormAnswerResponse",
        "kind": "LinkedField",
        "name": "createWebFormAnswer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "WebFormSubmission",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              (v9/*: any*/),
              (v11/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentUsage",
                "kind": "LinkedField",
                "name": "contentUsage",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v13/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentUsageNodeConnection",
                    "kind": "LinkedField",
                    "name": "dependents",
                    "plural": false,
                    "selections": (v15/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "module",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsageNodeConnection",
                        "kind": "LinkedField",
                        "name": "usages",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsageNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentUsage",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentUsageNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "dependents",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsageNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentUsage",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              (v14/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "Content",
                                                "kind": "LinkedField",
                                                "name": "content",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ContentUsageNodeConnection",
                                                    "kind": "LinkedField",
                                                    "name": "children",
                                                    "plural": false,
                                                    "selections": (v15/*: any*/),
                                                    "storageKey": null
                                                  },
                                                  (v2/*: any*/)
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v13/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ProductMembershipNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "completedProductMemberships",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ProductMembershipNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ProductMembership",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v2/*: any*/),
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "User",
                                                "kind": "LinkedField",
                                                "name": "member",
                                                "plural": false,
                                                "selections": [
                                                  (v2/*: any*/),
                                                  {
                                                    "alias": "first_name",
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "firstName",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": "last_name",
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "lastName",
                                                    "storageKey": null
                                                  },
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "avatar",
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentCompletionNodeConnection",
                        "kind": "LinkedField",
                        "name": "viewerChildContentCompletions",
                        "plural": false,
                        "selections": (v17/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductMembershipNodeConnection",
                    "kind": "LinkedField",
                    "name": "completedProductMemberships",
                    "plural": false,
                    "selections": (v17/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v12/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0c8d17e9e0b76773e65dfb39a5d4da24",
    "id": null,
    "metadata": {},
    "name": "QuizSubmissionEditorFormMutation",
    "operationKind": "mutation",
    "text": "mutation QuizSubmissionEditorFormMutation(\n  $input: CreateWebFormAnswerInput!\n) {\n  response: createWebFormAnswer(input: $input) {\n    node {\n      id\n      webFormId\n      webFormRevisionId\n      completedAt\n      durationSeconds\n      hasAnswerKey\n      hasPassed\n      answers {\n        edges {\n          node {\n            id\n            body\n            selectedOptions\n            webFormQuestionId\n            isSkipped\n            isCorrect\n            result {\n              correctIds\n              incorrectSelections\n            }\n          }\n        }\n      }\n      result {\n        score\n        total\n        percentage\n        correctAnswers {\n          id\n        }\n        incorrectAnswers {\n          id\n        }\n      }\n      contentUsage {\n        ...ContentUsageUtils_ContentCompletionFragment\n        id\n      }\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment ContentUsageUtils_ContentCompletionFragment on ContentUsage {\n  id\n  viewerHasCompleted\n  dependents {\n    edges {\n      node {\n        id\n        isLocked\n      }\n    }\n  }\n  module {\n    id\n    usages {\n      edges {\n        node {\n          id\n          dependents {\n            edges {\n              node {\n                id\n                isLocked\n                content {\n                  children {\n                    edges {\n                      node {\n                        id\n                        isLocked\n                      }\n                    }\n                  }\n                  id\n                }\n              }\n            }\n          }\n          viewerHasCompleted\n          completedProductMemberships {\n            totalCount\n            edges {\n              node {\n                id\n                member {\n                  id\n                  first_name: firstName\n                  last_name: lastName\n                  avatar\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    viewerChildContentCompletions {\n      totalCount\n    }\n  }\n  completedProductMemberships {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "82801cdb024e70b20ddc122d42231626";

export default node;
